import { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory, useLocation } from 'react-router-dom';

import {
  Container,
  Typography,
  AppBar,
  Tabs,
  Tab,
  Divider,
  Box,
} from '@material-ui/core';

import { TabPanel } from 'components';

import { InbodyTutorialPanel } from 'shared/components/tab-panels/inbody-tutorial-panel/inbody-tutorial-panel.component';
import { AccountTutorialPanel } from 'shared/components/tab-panels/account-tutorial-panel/account-tutorial.panel';
import { NutritionistTutorialPanel } from 'shared/components/tab-panels/nutritionist-tutorial-panel/nutritionist-tutorial.panel';

import { useStyles } from './tutorials-page.styles';

export const TutorialsPage = () => {
  const [tab, setTab] = useState(0);

  const { search } = useLocation();
  const history = useHistory();

  const onChangeTabHandler = (_, tabValue) => {
    const queryString =
      {
        0: 'inbody',
        1: 'nutritionist',
        2: 'account',
      }[tabValue] || 'inbody';

    const urlParams = new URLSearchParams(search);
    urlParams.set('page', queryString);
    history.replace({
      pathname: history.location.pathname,
      search: urlParams.toString(),
    });
  };

  const urlParams = useMemo(() => {
    const searchParams = new URLSearchParams(search);

    return {
      page: searchParams.get('page'),
    };
  }, [search]);

  useEffect(() => {
    const tabIndex =
      {
        inbody: 0,
        nutritionist: 1,
        account: 2,
      }[urlParams.page] || 0;

    setTab(tabIndex);
  }, [urlParams.page]);

  const classes = useStyles();

  return (
    <Box>
      <Helmet>
        <title>Tutoriales | Wellnub</title>
      </Helmet>
      <Container className={classes.container}>
        <Typography className={classes.title} variant="h4" component="h1">
          Tutoriales
        </Typography>

        <Divider className={classes.divider} />

        <AppBar position="static" classes={{ root: classes.appbar }}>
          <Tabs
            variant="fullWidth"
            value={tab}
            onChange={onChangeTabHandler}
            indicatorColor="primary"
            classes={{ root: classes.tabs }}
          >
            <Tab
              label="Inbodys"
              classes={{
                root: classes.tab,
                selected: classes.selected,
              }}
            />
            <Tab
              label="Mi nutriólogo"
              classes={{
                root: classes.tab,
                selected: classes.selected,
              }}
            />
            <Tab
              label="Mi cuenta"
              classes={{ root: classes.tab, selected: classes.selected }}
            />
          </Tabs>
        </AppBar>

        <Box component="section" mt={4}>
          <TabPanel value={tab} index={0}>
            <InbodyTutorialPanel />
          </TabPanel>
          <TabPanel value={tab} index={1}>
            <NutritionistTutorialPanel />
          </TabPanel>
          <TabPanel value={tab} index={2}>
            <AccountTutorialPanel />
          </TabPanel>
        </Box>
      </Container>
    </Box>
  );
};
